import Guard from '../../services/Middleware'

export default [
  {
    path: '/Alugueis',
    name:'Aluguel',
    component: () => import('@/views/alugueis/index.vue'),
    beforeEnter: Guard.auth
  },
]